import { render, staticRenderFns } from "./BlockPriceForm.vue?vue&type=template&id=94e6df32&scoped=true"
import script from "./BlockPriceForm.vue?vue&type=script&lang=js"
export * from "./BlockPriceForm.vue?vue&type=script&lang=js"
import style0 from "./BlockPriceForm.vue?vue&type=style&index=0&id=94e6df32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e6df32",
  null
  
)

export default component.exports